import React from 'react';
import { SiteShellProps } from 'src/config/sites/SiteDefinition';
import { TagManager } from 'src/core/TagManager';

const LamanteShell: React.FC<SiteShellProps> = ({ children }) => (
    <>
        <TagManager />
        {children}
    </>
);

export default LamanteShell;
